import { orderBy } from 'lodash';

import CoreUtils from '../../common/utils/CoreUtils';

import OptableDataModel from '../optable/OptableDataModel';

export default class OptOutDataModel extends OptableDataModel {
  constructor(locale, counterparty, commandDataModel, summaryDataModel) {
    super(locale, counterparty, commandDataModel, 'isOptedOut', false)

    this.summaryDataModel = summaryDataModel;
  }

  processOptableContract(contractDto, contract) {
    super.processOptableContract(contractDto, contract);

    var maximumOptOutsPerMonth = parseInt(contractDto.parameters.MaximumOptOutsPerMonth);
    
    contract.maximumOptOutCount = maximumOptOutsPerMonth;
    contract.remainingOptOutCount = maximumOptOutsPerMonth;
    contract.currentOptOutCount = 0;
    contract.isOptOutExceeded = false;
  }

  updateOverallStatus() {
    super.updateOverallStatus();

    CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
      contract.remainingOptOutCount = contract.maximumOptOutCount;
      contract.currentOptOutCount = 0;
      contract.isOptOutExceeded = false;
    });

    var isOptOutExceeded = false;

    CoreUtils.iterateProperties(this.indexedSchedules, (_, schedule) => {
      var contract = this.indexedContracts[schedule.contractCode];
      if (contract === undefined)
        return;

      if (schedule[this.optedDataField]) {
        contract.remainingOptOutCount -= 1;
        contract.currentOptOutCount += 1;
      }

      contract.isOptOutExceeded = contract.maximumOptOutCount > 0
        && contract.currentOptOutCount > contract.maximumOptOutCount;

      if (contract.isOptOutExceeded)
        isOptOutExceeded = true;
    });

    if (CoreUtils.isDefinedAndNotNull(this.summaryDataModel)) {
      var contracts = [];
      CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
        contracts.push(contract);
      });

      this.summaryDataModel.updateProperties({
        contracts: orderBy(contracts, ['code'], ['asc']),
        isOptingLimitExceeded: isOptOutExceeded
      });
    }

    this.hasValidationErrors = isOptOutExceeded;

    if (CoreUtils.isDefinedAndNotNull(this.commandDataModel)) {
      this.commandDataModel.updateProperties({
        hasValidationErrors: this.hasValidationErrors
      });
    }
  }
}